import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/articles/${article.id}`}
      className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col"
    >
      <div className="relative overflow-hidden">
        <div className="w-full aspect-[16/9] bg-background-100">
          <img
            src={article.coverImage}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-md">
          {article.category}
        </span>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors duration-200 font-heading">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed flex-1">
          {article.summary}
        </p>
        <div className="flex items-center justify-between pt-3 border-t border-background-200/50">
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-user-line text-xs"></i>
              </span>
              {article.author}
            </span>
            <span className="flex items-center gap-1">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-time-line text-xs"></i>
              </span>
              {article.readTime}
            </span>
          </div>
          <span className="text-xs text-foreground-400">{article.publishDate}</span>
        </div>
      </div>
    </Link>
  );
}